import { createFileRoute, Link } from "@tanstack/react-router";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";

export const Route = createFileRoute("/privacy")({
  head: () => ({
    meta: [
      { title: "Privacy Policy — Mr. B Quotes" },
      { name: "description", content: "How Mr. B Quotes (mrbquotes.com) handles your data. We don't use accounts, we don't sell data, and game progress is stored only on your device." },
      { property: "og:title", content: "Privacy Policy — Mr. B Quotes" },
      { property: "og:url", content: "/privacy" },
    ],
    links: [{ rel: "canonical", href: "/privacy" }],
  }),
  component: Privacy,
});

function Privacy() {
  return (
    <div className="min-h-screen">
      <SiteHeader />
      <main id="main">
      <article className="mx-auto max-w-3xl px-4 py-16 sm:py-20 prose prose-invert max-w-none">
        <div className="text-[10px] uppercase tracking-[0.3em] text-muted-foreground">Legal</div>
        <h1 className="mt-2 font-display text-4xl sm:text-5xl text-foreground">Privacy Policy</h1>
        <p className="text-xs text-muted-foreground">Last updated: June 25, 2026</p>

        <p className="text-muted-foreground mt-6">
          This page describes how <strong className="text-foreground">Mr. B Quotes</strong> (mrbquotes.com) handles information when you visit our site or play our games.
          We've tried to keep it plain.
        </p>

        <h2 className="font-display text-2xl text-gold mt-10">What we collect</h2>
        <p className="text-muted-foreground">
          We do not require accounts and we do not collect personal information such as your name, email address, or location.
        </p>

        <h2 className="font-display text-2xl text-gold mt-8">Game progress (local only)</h2>
        <p className="text-muted-foreground">
          When you play a Mr. B Quotes game, your best scores, streaks, and level stars are saved in your browser's
          <code> localStorage</code>. This data stays on your device. We never see it. Clearing your browser data removes it.
        </p>

        <h2 className="font-display text-2xl text-gold mt-8">Embedded content (YouTube)</h2>
        <p className="text-muted-foreground">
          Our home page may embed videos from YouTube. When you interact with a YouTube embed, YouTube (a Google service) may
          set cookies and collect data according to <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-gold hover:underline">Google's Privacy Policy</a>.
          We use <code>youtube-nocookie.com</code> where possible to reduce tracking until you press play.
        </p>

        <h2 className="font-display text-2xl text-gold mt-8">Analytics</h2>
        <p className="text-muted-foreground">
          We may use privacy-respecting, aggregate analytics to count page views and understand which games are popular.
          No personal profiles are built.
        </p>

        <h2 className="font-display text-2xl text-gold mt-8">Sharing</h2>
        <p className="text-muted-foreground">
          We do not sell, rent, or share any visitor information with third parties.
        </p>

        <h2 className="font-display text-2xl text-gold mt-8">Children</h2>
        <p className="text-muted-foreground">
          Mr. B Quotes is suitable for all ages. We do not knowingly collect data from anyone, regardless of age.
        </p>

        <h2 className="font-display text-2xl text-gold mt-8">Contact</h2>
        <p className="text-muted-foreground">
          Questions? Reach us through the <a href="https://www.youtube.com/@ministerjeb" target="_blank" rel="noopener noreferrer" className="text-gold hover:underline">@ministerjeb</a> YouTube channel.
        </p>

        <p className="text-xs text-muted-foreground mt-12">
          See also: <Link to="/terms" className="text-gold hover:underline">Terms of Use</Link>.
        </p>
      </article>
      </main>
      <SiteFooter />
    </div>
  );
}
